import { price as priceUtil } from '@eti/utils';
import { ExpandableContent, ScreenReaderPrice } from '@eti/components';
import { Text, textVariants } from '@etg/wings';
import { css, etiColors } from '@eti/styles';
import useId from '../hooks/useId';
import { useToggle } from '../../../common/custom-hooks/toggle';
import { CartRow, Price } from './CartComponents';
import { RowToggle } from './CartToggleableRow';

const listStyles = css`
  color: ${etiColors.grayScale[10]};
  display: flex;
  justify-content: space-between;
`;

const passContainerStyles = css`
  align-items: center;
  direction: ltr;
  display: inline-flex;
  gap: 3px;
  margin-inline-start: 10px;
`;

const passStyles = css`
  margin: 0;
`;

interface CartAvailability {
  airportList: {
    airportName: string;
    numberOfPass: number;
  }[];
  passLabel: string;
}

interface CartFastTrackProps {
  dataTestId: string;
  title: string;
  price: number;
  availability: CartAvailability;
}

const CartBreakdownRow = ({ dataTestId, title, price, availability }: CartFastTrackProps) => {
  const { isOpen, handleToggle } = useToggle(false);
  const uniqueId = useId();
  const { airportList, passLabel } = availability;

  return (
    <>
      <CartRow data-testid={dataTestId}>
        <RowToggle
          dataTestId={`${dataTestId}-toggle`}
          id={uniqueId}
          isExpanded={isOpen}
          onClick={handleToggle}
        >
          {title}
        </RowToggle>

        {price && (
          <>
            <Price aria-hidden data-testid={`${dataTestId}-price`}>
              {priceUtil.formatPrice(price)}
            </Price>
            <ScreenReaderPrice price={priceUtil.formatPrice(price)} />
          </>
        )}
      </CartRow>

      <ExpandableContent isExpanded={airportList && isOpen}>
        <ul>
          {airportList.map(({ airportName, numberOfPass }, index: number) => (
            <li
              className={listStyles}
              data-testid={`${dataTestId}-dataRow`}
              key={`subsection-${index}`}
            >
              <Text variant={textVariants._12}>{airportName}</Text>
              <div className={passContainerStyles}>
                <Text className={passStyles} variant={textVariants._12}>
                  {numberOfPass}
                </Text>
                <Text className={passStyles} variant={textVariants._12}>
                  {passLabel}
                </Text>
              </div>
            </li>
          ))}
        </ul>
      </ExpandableContent>
    </>
  );
};

export default CartBreakdownRow;
